import InfoRegular from 'mini-fluent-svg-icons/lib/icons/InfoRegular';
import { showToast } from 'mini-toast';

export function showToastWithErrorMsg(errorMessage: string) {
    const icon: string = InfoRegular;
    showToast({ label: errorMessage, icon });
}
